import React, { useState, useEffect, useRef } from "react";
import "./DashboardHeader.css";
import { Link, useLocation } from "react-router-dom";
import AddMedicine from "../DoctorNotes/Modal/AddMedicine/AddMedicine";
import AddtestPopup from "../DoctorNotes/Modal/AddMedicine/AddtestPopup";
import CustomBotton from "../../../Components/CustomButton";
import { usePermissions } from "../../../hooks/usePermissions";

const DashboardHeader = () => {
  const { canSeeDentalChart } = usePermissions();
  const [activeLink, setActiveLink] = useState("history");
  const [isMedicineModalOpen, setIsMedicineModalOpen] = useState(false);
  const [isTestModalOpen, setIsTestModalOpen] = useState(false);
  const medicineModalRef = useRef();
  const testModalRef = useRef();
  const location = useLocation();

  // Derive active tab from the current URL so the highlight survives page refresh
  // and direct navigation (fixes the original "always resets to history" bug).
  useEffect(() => {
    const path = location.pathname;
    if (path.includes("/dental"))        setActiveLink("dental");
    else if (path.includes("/doctornotes")) setActiveLink("doctornotes");
    else if (path.includes("/records"))     setActiveLink("records");
    else if (path.includes("/visualization")) setActiveLink("visualization");
    else                                    setActiveLink("history");
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        medicineModalRef.current &&
        !medicineModalRef.current.contains(event.target)
      ) {
        setIsMedicineModalOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [medicineModalRef]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        testModalRef.current &&
        !testModalRef.current.contains(event.target)
      ) {
        setIsTestModalOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [testModalRef]);

  return (
    <div className="dashboadr-header_container">
      <div className={`div-dashboard-header ${activeLink === "visualization" ? "" : "headerActive"}`}>
        <Link
          className={`link ${activeLink === "history" ? "active" : ""}`}
          to="/DashboardDashboardNavigation"
          onClick={() => setActiveLink("history")}
        >
          <span className="dashboard__header-tital">History</span>
        </Link>
        <Link
          className={`link ${activeLink === "doctornotes" ? "active" : ""}`}
          to="/DashboardDashboardNavigation/doctornotes"
          onClick={() => setActiveLink("doctornotes")}
        >
          <span className="dashboard__header-tital">Doctor Notes</span>
        </Link>
        <Link
          className={`link ${activeLink === "records" ? "active" : ""}`}
          to="/DashboardDashboardNavigation/records"
          onClick={() => setActiveLink("records")}
        >
          <span className="dashboard__header-tital">Records</span>
        </Link>
        <Link
          className={`link ${activeLink === "visualization" ? "active" : ""}`}
          to="/DashboardDashboardNavigation/visualization"
          onClick={() => setActiveLink("visualization")}
        >
          <span className="dashboard__header-tital">Data Visualization</span>
        </Link>
        {canSeeDentalChart && (
          <Link
            className={`link ${activeLink === "dental" ? "active" : ""}`}
            to="/DashboardDashboardNavigation/dental"
            onClick={() => setActiveLink("dental")}
          >
            <span className="dashboard__header-tital">Dental Chart</span>
          </Link>
        )}
        <div className="button">
          <CustomBotton onClick={() => setIsTestModalOpen(true)}>
            Add Tests
          </CustomBotton>
          <CustomBotton onClick={() => setIsMedicineModalOpen(true)}>
            Add Medicine
          </CustomBotton>
        </div>
        {isMedicineModalOpen && (
          <AddMedicine setIsMedicineModalOpen={setIsMedicineModalOpen} />
        )}
        {isTestModalOpen && (
          <AddtestPopup setIsTestModalOpen={setIsTestModalOpen} />
        )}
      </div>
      <hr style={{ background: "#f1f1f1", height: "1px", width: "100vw" }} />
    </div>
  );
};

export default DashboardHeader;